import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import { toast } from 'react-toastify';
import { uploadAsset } from '~/store/mediaUpload';

export const effect = createListenerEffect(
  'mediaUpload/toastUploadFailed<Listener>',
  async (action, { dispatch, getState, trigger }) => {
    const { file } = action.meta.arg;
    toast.error(`Something went wrong while uploading ${file?.name}. Please try again.`);
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  actionCreator: uploadAsset.rejected,
  effect,
});

export default middleware;
